import { isStreamingEnabled } from './isStreamingEnabled.tsx';

export const useIsStreamingEnabled = (): boolean => {
	return isStreamingEnabled();
};
